module.exports = __webpack_public_path__ + "static/footerPrefaceRight-72d8af27b04b00c143273d03e6e46689.jpg";